import { App, message } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';
import React from 'react';

let messageInstance: MessageInstance | null = null;

const getMessageApi = () => messageInstance ?? message;

export const setAppMessageInstance = (instance: MessageInstance | null) => {
  messageInstance = instance;
};

export const appMessage = {
  success: (content: React.ReactNode) => getMessageApi().success(content),
  error: (content: React.ReactNode) => getMessageApi().error(content),
  warning: (content: React.ReactNode) => getMessageApi().warning(content),
  info: (content: React.ReactNode) => getMessageApi().info(content),
};

export const AppMessageBridge: React.FC = () => {
  const { message } = App.useApp();

  React.useEffect(() => {
    setAppMessageInstance(message);
    return () => setAppMessageInstance(null);
  }, [message]);

  return null;
};
